import "./Events.css";
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
// import editIcon from "../assets/icons/edit.png";
// import deleteIcon from "../assets/icons/delete.png";
// import BackIcon from "../assets/icons/arrow.png";
import { useAuthStore } from "../Services/authStore";
// import { toastSuccess, toastError, toastWarning } from "../Services/toaster";
import ApprovalView from "./ApprovalView";
// import editIcon from "../assets/icons/edit.png";
import BackIcon from "../assets/icons/arrow.png";
import eventIcon from "../assets/icons/wine (1).png";
import approveIcon from "../assets/icons/approve.png";
import calenderIcon from "../assets/icons/calendar.png";
import clockIcon from "../assets/icons/clock.png";
import locationIcon from "../assets/icons/location.png";
import memberIcon from "../assets/icons/community.png";
import nonmemberIcon from "../assets/icons/team.png";
import dressIcon from "../assets/icons/attire.png";

const STATUS_TABS = ["All", "Announced", "Open", "Completed", "Cancelled"];
const STEPS = ["Basic Info", "Attendees", "Experience", "Vendors", "Activity"];

const EMPTY_FORM = {
  event_title: "",
  event_category: "",
  event_date: "",
  checkin_time: "",
  dinner_time: "",
  venue: "",
  status: "Draft",
  capacity: "",
  member_price: "",
  non_member_price: "",
  description: "",
  booking_deadline: "",
  dress_code: "",
  whats_included: "",
  special_guest: "",
  menu: "",
  special_notes: "",
  approval_status: "Pending",
  banner: null,
  gallery_images: [],
  vendors: [],
  activities: [],
  approvals: [],
};

const EMPTY_ACTIVITY = {
  id: 0,
  activity_title: "",
  start_date: "",
  end_date: "",
  assignee: "",
  description: "",
  budget: "",
  status: "Pending",
};

function fmt(n) {
  return Number(n).toLocaleString("vi-VN") + "₫";
}

// ─────────────────────────────────────────────────────────
//  SHARED — Status badge
// ─────────────────────────────────────────────────────────
function StatusBadge({ status }) {
  const map = {
    Completed: "ev-s-completed",
    Announced: "ev-s-announced",
    Open: "ev-s-open",
    Cancelled: "ev-s-cancelled",
    Draft: "ev-s-draft",
    Pending: "ev-s-draft",
  };
  return (
    <span className={`ev-status-badge ${map[status] || "ev-s-draft"}`}>
      ● {status}
    </span>
  );
}

// ─────────────────────────────────────────────────────────
//  SHARED — Step bar
// ─────────────────────────────────────────────────────────
function StepBar({ current }) {
  return (
    <div className="ev-stepbar">
      {STEPS.map((s, i) => (
        <div
          key={s}
          className={`ev-step-item ${i === current ? "ev-step-active" : ""} ${i < current ? "ev-step-done" : ""}`}
        >
          <div className="ev-step-circle">
            {i < current ? (
              <span className="ev-step-check">✓</span>
            ) : (
              <span className="ev-step-number">{i + 1}</span>
            )}
          </div>
          <span className="ev-step-label">{s}</span>
          {i < STEPS.length - 1 && <div className="ev-step-connector" />}
        </div>
      ))}
    </div>
  );
}

// ─────────────────────────────────────────────────────────
//  SHARED — Success modal
// ─────────────────────────────────────────────────────────
function SuccessModal({ eventTitle, onClose }) {
  return (
    <div className="ev-modal-overlay">
      <div className="ev-modal">
        <div className="ev-modal-icon">🎉</div>
        <h2 className="ev-modal-title">Event Created!</h2>
        <p className="ev-modal-desc">
          <strong>"{eventTitle}"</strong> has been created successfully and is
          pending approval.
        </p>
        <div className="ev-modal-actions">
          <button className="ev-modal-btn" onClick={onClose}>
            Back to Events
          </button>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────
//  EVENT CARD
// ─────────────────────────────────────────────────────────
function EventCard({ event, onEdit }) {
  return (
    <div className="ev-card">
      <div
        className="ev-card-banner"
        style={{
          background: `linear-gradient(160deg,${event.banner_color || "#2C3639"} 0%,#1a1a1a 100%)`,
        }}
      >
        <div className="ev-card-banner-overlay" />
        <span className="ev-card-act-badge">
          {Array.isArray(event.activities)
            ? event.activities.length
            : event.activities || 0}{" "}
          activities
        </span>
        <StatusBadge status={event.status} />
      </div>
      <div className="ev-card-body">
        <h3 className="ev-card-title">{event.event_title || event.title}</h3>

        {/* Date and Time */}
        <div className="ev-card-meta-row">
          <span className="ev-meta-chip">
            <img src={calenderIcon} alt="Date" className="ev-meta-icon" />
            {event.event_date || event.date}
          </span>

          <span className="ev-meta-chip">
            <img src={clockIcon} alt="Time" className="ev-meta-icon" />
            {event.checkin_time} check-in
          </span>
        </div>

        {/* Venue */}
        <div className="ev-card-meta-row" style={{ marginBottom: 12 }}>
          <span className="ev-meta-chip ev-meta-venue">
            <img src={locationIcon} alt="Location" className="ev-meta-icon" />
            {event.venue}
          </span>
        </div>

        {/* Prices and Dress Code */}
        <div className="ev-price-row">
          <div className="ev-price-tag ev-price-member">
            <span className="ev-price-icon">
              <img src={memberIcon} alt="Member" />
            </span>
            <span>{fmt(event.member_price || 0)}</span>
          </div>

          <div className="ev-price-tag ev-price-guest">
            <span className="ev-price-icon">
              <img src={nonmemberIcon} alt="Guest" />
            </span>
            <span>{fmt(event.non_member_price || 0)}</span>
          </div>

          <div className="ev-price-tag ev-price-dress">
            <span className="ev-price-icon">
              <img src={dressIcon} alt="Dress Code" />
            </span>
            <span>{event.dress_code || "—"}</span>
          </div>
        </div>

        <p className="ev-card-desc">+ {event.description}</p>

        <div className="ev-card-btns">
          <button className="ev-btn ev-btn-ghost" onClick={() => onEdit(event)}>
            Edit
          </button>
        </div>
      </div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════
//  EVENTS VIEW
// ═════════════════════════════════════════════════════════
function EventsView() {
  const [activeTab, setActiveTab] = useState("All");
  const [showForm, setShowForm] = useState(false);
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({ ...EMPTY_FORM });
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [listError, setListError] = useState("");
  const [formError, setFormError] = useState("");
  const [menuImgCount, setMenuImgCount] = useState(0);
  const [showActForm, setShowActForm] = useState(false);
  const [newAct, setNewAct] = useState({ ...EMPTY_ACTIVITY });
  const [showSuccess, setShowSuccess] = useState(false);
  const [createdTitle, setCreatedTitle] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editEventId, setEditEventId] = useState(null);
  const [approvedVendors, setApprovedVendors] = useState([]);
  const token = useAuthStore((s) => s.token);
  const API = process.env.REACT_APP_API_URL;
  const authHeaders = useCallback(
    () => ({
      Authorization: `Bearer ${token}`,
      accept: "application/json",
    }),
    [token],
  );
  const fetchApprovedVendors = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/vendor/my-approvals-vendor`, {
        headers: authHeaders(),
      });

      console.log("APPROVED VENDORS API RESPONSE:", res.data);

      const rawData = res.data?.data ?? res.data;

      // Handle both:
      // { data: [...] }
      // and
      // { data: { data: [...] } }
      const data = Array.isArray(rawData)
        ? rawData
        : Array.isArray(rawData?.data)
          ? rawData.data
          : [];

      const approved = data.filter((vendor) => {
        const status = String(
          vendor.vendor_status ??
            vendor.status ??
            vendor.approval_status ??
            vendor.vendor_approval_status ??
            "",
        )
          .trim()
          .toLowerCase();

        return status === "approved";
      });

      console.log("ALL VENDORS:", data);
      console.log("APPROVED VENDORS:", approved);

      setApprovedVendors(approved);
    } catch (err) {
      console.error(
        "Failed to fetch approved vendors:",
        err.response?.data || err,
      );

      setApprovedVendors([]);
    }
  }, [API, authHeaders]);
  const fetchEvents = useCallback(async () => {
    setLoading(true);
    setListError("");
    try {
      const res = await axios.get(`${API}/events/list`, {
        headers: authHeaders(),
      });
      const raw = res.data?.data || res.data;
      setEvents(Array.isArray(raw) ? raw : []);
    } catch (err) {
      console.error(err.response?.data);
      setListError("Failed to load events.");
    } finally {
      setLoading(false);
    }
  }, [API, authHeaders]);

  useEffect(() => {
    fetchEvents();
    fetchApprovedVendors();
  }, [fetchEvents, fetchApprovedVendors]);

  const openEdit = async (event) => {
    const id = event.id || event.event_id;
    setFormError("");
    setIsEditMode(true);
    setEditEventId(id);
    setStep(0);
    setMenuImgCount(0);
    setShowActForm(false);
    setShowForm(true);
    setFormLoading(true);
    try {
      const res = await axios.get(`${API}/events/${id}`, {
        headers: authHeaders(),
      });
      const d = res.data?.data || res.data;
      setForm({
        event_title: d.event_title || "",
        event_category: d.event_category || "",
        event_date: d.event_date || "",
        checkin_time: d.checkin_time || "",
        dinner_time: d.dinner_time || "",
        venue: d.venue || "",
        status: d.status || "Draft",
        capacity: d.capacity || "",
        member_price: d.member_price || "",
        non_member_price: d.non_member_price || "",
        description: d.description || "",
        booking_deadline: d.booking_deadline || "",
        dress_code: d.dress_code || "",
        whats_included: d.whats_included || "",
        special_guest: d.special_guest || "",
        menu: d.menu || "",
        special_notes: d.special_notes || "",
        approval_status: d.approval_status || "Pending",
        banner: null,
        gallery_images: [],
        vendors: Array.isArray(d.vendors) ? d.vendors : [],
        activities: Array.isArray(d.activities) ? d.activities : [],
        approvals: Array.isArray(d.approvals) ? d.approvals : [],
      });
    } catch (err) {
      setFormError("Failed to load event details.");
    } finally {
      setFormLoading(false);
    }
  };
  const openAdd = async () => {
    setFormLoading(true);
    setFormError("");

    try {
      // Document code from Document Master
      const documentCode = "EVT";

      // Get approval matrix using document CODE
      const res = await axios.get(`${API}/approval/document/${documentCode}`, {
        headers: authHeaders(),
      });

      const approvalData = res.data?.data || [];

      const approvals = approvalData.map((item) => ({
        approval_level: item.approval_level,
        approver_user_id: item.approver_user_id,
        status: "Pending",
        remarks: "",
      }));

      setForm({
        ...EMPTY_FORM,
        approvals,
      });

      console.log("Document Code:", documentCode);
      console.log("Approval Data:", approvalData);
      console.log("Approvals:", approvals);
    } catch (err) {
      console.error(
        "Failed to fetch approval document:",
        err.response?.data || err,
      );

      setForm({
        ...EMPTY_FORM,
        approvals: [],
      });

      setFormError(
        err.response?.data?.detail ||
          "Failed to load Event approval configuration.",
      );
    } finally {
      setStep(0);
      setMenuImgCount(0);
      setShowActForm(false);
      setIsEditMode(false);
      setEditEventId(null);
      setShowForm(true);
      setFormLoading(false);
    }
  };
  const closeForm = () => {
    setShowForm(false);
    setFormError("");
  };
  const setF = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const goNext = () => {
    if (step < STEPS.length - 1) setStep((s) => s + 1);
  };
  const goBack = () => {
    if (step > 0) setStep((s) => s - 1);
  };

  const buildPayload = (forEdit = false) => {
    const obj = {
      event_title: form.event_title,
      event_category: form.event_category || "General",
      event_date: form.event_date,
      checkin_time: form.checkin_time || "",
      dinner_time: form.dinner_time || "",
      venue: form.venue,
      status: form.status,

      capacity: parseInt(form.capacity, 10) || 0,

      member_price: Number(form.member_price) || 0,
      non_member_price: Number(form.non_member_price) || 0,

      description: form.description,

      booking_deadline: form.booking_deadline || null,

      dress_code: form.dress_code,
      whats_included: form.whats_included,
      special_guest: form.special_guest,
      menu: form.menu,
      special_notes: form.special_notes,

      approval_status: form.approval_status || "Pending",

      vendors: Array.isArray(form.vendors) ? form.vendors : [],

      activities: (form.activities || []).map((a) => ({
        id: forEdit ? Number(a.id) || 0 : 0,
        activity_title: a.activity_title?.trim() || "",
        start_date: a.start_date || "",
        end_date: a.end_date || "",
        assignee: Number(a.assignee) || 0,
        description: a.description || "",
        budget: Number(a.budget) || 0,
        status: a.status || "Pending",
      })),
      approvals: Array.isArray(form.approvals)
        ? form.approvals.map((a) => ({
            approval_level: a.approval_level,
            approver_user_id: a.approver_user_id,
            status: a.status || "Pending",
            remarks: a.remarks || "",
          }))
        : [],
    };

    console.log("========== EVENT PAYLOAD ==========");
    console.log(JSON.stringify(obj, null, 2));
    console.log("ACTIVITIES COUNT:", obj.activities.length);
    console.log("ACTIVITIES:", obj.activities);

    const fd = new FormData();

    fd.append("request", JSON.stringify(obj));

    if (form.banner instanceof File) {
      fd.append("files", form.banner);
      fd.append("image_types", "banner");
    }

    (form.gallery_images || []).forEach((file) => {
      if (file instanceof File) {
        fd.append("files", file);
        fd.append("image_types", "gallery");
      }
    });

    return fd;
  };

  const parseErr = (err, fb) => {
    const d = err.response?.data?.detail;
    return Array.isArray(d)
      ? d.map((x) => `${x.loc?.join(".")} — ${x.msg}`).join("\n")
      : d || fb;
  };

  const handleCreate = async () => {
    setFormError("");
    if (!form.event_title.trim()) {
      setFormError("Event title is required.");
      return;
    }
    setFormLoading(true);
    try {
      const t = useAuthStore.getState().token;
      await axios.post(`${API}/events/add`, buildPayload(false), {
        headers: { Authorization: `Bearer ${t}`, accept: "application/json" },
      });
      setCreatedTitle(form.event_title);
      setShowForm(false);
      setShowSuccess(true);
      fetchEvents();
    } catch (err) {
      setFormError(parseErr(err, "Failed to create event."));
    } finally {
      setFormLoading(false);
    }
  };

  const handleUpdate = async () => {
    setFormError("");

    if (!form.event_title.trim()) {
      setFormError("Event title is required.");
      return;
    }

    setFormLoading(true);

    try {
      const t = useAuthStore.getState().token;

      const payload = buildPayload(true);

      for (const [key, value] of payload.entries()) {
        console.log(
          key,
          value instanceof File
            ? {
                name: value.name,
                type: value.type,
                size: value.size,
              }
            : value,
        );
      }

      await axios.put(`${API}/events/update/${editEventId}`, payload, {
        headers: {
          Authorization: `Bearer ${t}`,
          accept: "application/json",
        },
      });

      setShowForm(false);
      fetchEvents();
    } catch (err) {
      console.error("UPDATE ERROR:", err.response?.data || err);
      setFormError(parseErr(err, "Failed to update event."));
    } finally {
      setFormLoading(false);
    }
  };

  const addActivity = () => {
    if (!newAct.activity_title.trim()) {
      setFormError("Activity title is required.");
      return;
    }

    const activity = {
      id: 0,
      activity_title: newAct.activity_title.trim(),
      start_date: newAct.start_date || "",
      end_date: newAct.end_date || "",
      assignee: Number(newAct.assignee) || 0,
      description: newAct.description || "",
      budget: Number(newAct.budget) || 0,
      status: newAct.status || "Pending",
    };

    setForm((prev) => {
      const updatedActivities = [
        ...(Array.isArray(prev.activities) ? prev.activities : []),
        activity,
      ];

      console.log("ACTIVITY ADDED TO FORM:", activity);
      console.log("ALL FORM ACTIVITIES:", updatedActivities);

      return {
        ...prev,
        activities: updatedActivities,
      };
    });

    setNewAct({ ...EMPTY_ACTIVITY });
    setShowActForm(false);
    setFormError("");
  };
  useEffect(() => {
    console.log("FORM ACTIVITIES CHANGED:", form.activities);
  }, [form.activities]);
  const filtered =
    activeTab === "All"
      ? events
      : activeTab === "Drafts"
        ? events.filter((e) => e.status === "Draft")
        : events.filter((e) => e.status === activeTab);

  // ── CREATE / EDIT FORM ──
  if (showForm)
    return (
      <div className="ev-form-page">
        <div className="ev-form-header">
          <div className="ev-form-header-left">
            <div className="back-btn-event">
              <button className="back-back-btn-event" onClick={closeForm}>
                <img src={BackIcon} alt="Back" className="back-icon" />
              </button>
            </div>
            <div>
              <h2 className="ev-form-title">
                {isEditMode ? "Edit Event" : "Create Event"}
              </h2>
              <p className="ev-form-subtitle">
                Fill in the details across each step
              </p>
            </div>
          </div>
        </div>

        <StepBar current={step} />
        {formLoading && (
          <div
            className="ev-fcard"
            style={{
              textAlign: "center",
              color: "#9F8E87",
              fontSize: 13,
              padding: 24,
            }}
          >
            Loading…
          </div>
        )}
        {formError && <div className="ev-form-error">{formError}</div>}

        {step === 0 && !formLoading && (
          <div className="ev-fcard">
            <div className="ev-fcard-eyebrow">Basic Information</div>
            <div className="ev-fgrid">
              <div className="ev-fgroup ev-fcol-full">
                <label>Event Title *</label>
                <input
                  value={form.event_title}
                  onChange={(e) => setF("event_title", e.target.value)}
                  placeholder="e.g. Spring Gala 2026"
                />
              </div>
              <div className="ev-fgroup">
                <label>Category</label>
                <input
                  value={form.event_category}
                  onChange={(e) => setF("event_category", e.target.value)}
                  placeholder="e.g. Dining Event"
                />
              </div>
              <div className="ev-fgroup">
                <label>Status</label>
                <select
                  value={form.status}
                  onChange={(e) => setF("status", e.target.value)}
                >
                  <option value="Draft">Draft</option>
                  <option value="Open">Open</option>
                  <option value="Announced">Announced</option>
                </select>
              </div>
              <div className="ev-fgroup">
                <label>Date *</label>
                <input
                  type="date"
                  value={form.event_date}
                  onChange={(e) => setF("event_date", e.target.value)}
                />
              </div>
              <div className="ev-fgroup">
                <label>Check-in Time</label>
                <input
                  type="time"
                  value={form.checkin_time}
                  onChange={(e) => setF("checkin_time", e.target.value)}
                />
              </div>
              <div className="ev-fgroup">
                <label>Dinner Time</label>
                <input
                  type="time"
                  value={form.dinner_time}
                  onChange={(e) => setF("dinner_time", e.target.value)}
                />
              </div>
              <div className="ev-fgroup ev-fcol-full">
                <label>Venue *</label>
                <input
                  value={form.venue}
                  onChange={(e) => setF("venue", e.target.value)}
                  placeholder="Restaurant name and full address"
                />
              </div>
            </div>
          </div>
        )}

        {step === 1 && (
          <div className="ev-fcard">
            <div className="ev-fcard-eyebrow">Attendees & Pricing</div>
            <p className="ev-fcard-hint">
              Member price is the discounted rate for registered members.
            </p>
            <div className="ev-fgrid">
              <div className="ev-fgroup">
                <label>Capacity (seats)</label>
                <input
                  type="number"
                  min="1"
                  value={form.capacity}
                  onChange={(e) => setF("capacity", e.target.value)}
                  placeholder="e.g. 60"
                />
              </div>
              <div className="ev-fgroup">
                <label>Booking Deadline (optional)</label>
                <input
                  type="date"
                  value={form.booking_deadline}
                  onChange={(e) => setF("booking_deadline", e.target.value)}
                />
              </div>
              <div className="ev-fgroup">
                <label>Member Price (₫)</label>
                <input
                  type="number"
                  min="0"
                  value={form.member_price}
                  onChange={(e) => setF("member_price", e.target.value)}
                  placeholder="3000000"
                />
              </div>
              <div className="ev-fgroup">
                <label>Non-Member Price (₫)</label>
                <input
                  type="number"
                  min="0"
                  value={form.non_member_price}
                  onChange={(e) => setF("non_member_price", e.target.value)}
                  placeholder="3500000"
                />
              </div>
              <div className="ev-fgroup ev-fcol-full">
                <label>Description</label>
                <textarea
                  rows="4"
                  value={form.description}
                  onChange={(e) => setF("description", e.target.value)}
                  placeholder="Describe what guests can expect…"
                />
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="ev-fcard">
            <div className="ev-fcard-eyebrow">Experience</div>
            <div className="ev-fgrid">
              <div className="ev-fgroup">
                <label>Dress Code</label>
                <input
                  value={form.dress_code}
                  onChange={(e) => setF("dress_code", e.target.value)}
                  placeholder="e.g. Smart Casual"
                />
              </div>
              <div className="ev-fgroup">
                <label>Special Guest ⭐</label>
                <input
                  value={form.special_guest}
                  onChange={(e) => setF("special_guest", e.target.value)}
                  placeholder="e.g. Master Sommelier"
                />
              </div>
              <div className="ev-fgroup ev-fcol-full">
                <label>Banner Image</label>
                <div
                  className="ev-upload-area"
                  onClick={() => document.getElementById("ev-banner").click()}
                >
                  <span className="ev-upload-emoji">📷</span>
                  <span>
                    {form.banner ? form.banner.name : "Click to upload"}
                  </span>
                  <input
                    id="ev-banner"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => setF("banner", e.target.files[0])}
                  />
                </div>
              </div>
              <div className="ev-fgroup ev-fcol-full">
                <label>What's Included</label>
                <textarea
                  rows="3"
                  value={form.whats_included}
                  onChange={(e) => setF("whats_included", e.target.value)}
                  placeholder="e.g. Welcome champagne, 4-course menu…"
                />
              </div>
              <div className="ev-fgroup ev-fcol-full">
                <label>Menu</label>
                <p className="ev-field-note">
                  🍽 List each course or dish on a separate line.
                </p>
                <textarea
                  rows="6"
                  value={form.menu}
                  onChange={(e) => setF("menu", e.target.value)}
                  placeholder={
                    "Amuse-bouche\nFoie gras terrine\nSeabass with beurre blanc\nChocolate fondant"
                  }
                />
              </div>
              <div className="ev-fgroup ev-fcol-full">
                <label>
                  Gallery Images{" "}
                  <span className="ev-label-sub">(carousel — up to 8)</span>
                </label>
                <p className="ev-field-note">
                  📸 These appear as a scrollable carousel on the event page.
                </p>
                <div className="ev-img-grid">
                  {Array.from({ length: menuImgCount }).map((_, i) => (
                    <div key={i} className="ev-img-thumb">
                      <span>Image {i + 1}</span>
                    </div>
                  ))}
                  {menuImgCount < 8 && (
                    <div
                      className="ev-img-add"
                      onClick={() =>
                        document.getElementById("ev-gallery").click()
                      }
                    >
                      <span className="ev-img-plus">+</span>
                      <span>Add Image</span>
                      <input
                        id="ev-gallery"
                        type="file"
                        accept="image/*"
                        multiple
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const f = Array.from(e.target.files);
                          setF("gallery_images", [
                            ...form.gallery_images,
                            ...f,
                          ]);
                          setMenuImgCount((p) => Math.min(8, p + f.length));
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="ev-fgroup ev-fcol-full">
                <label>Special Notes</label>
                <textarea
                  rows="3"
                  value={form.special_notes}
                  onChange={(e) => setF("special_notes", e.target.value)}
                  placeholder="e.g. Carry ID Card"
                />
              </div>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="ev-fcard">
            <div className="ev-fcard-eyebrow">Vendors</div>
            <p className="ev-fcard-hint">
              Enter vendor IDs to assign from the Vendor directory.
            </p>
            <div className="ev-vendor-manual">
              {form.vendors.map((v, i) => (
                <div key={i} className="ev-vendor-row">
                  <select
                    className="ev-vendor-id-input"
                    value={v.vendor_id || ""}
                    onChange={(e) => {
                      const u = [...form.vendors];

                      u[i] = {
                        ...u[i],
                        vendor_id: Number(e.target.value),
                      };

                      setF("vendors", u);
                    }}
                  >
                    <option value="">Select Vendor</option>

                    {approvedVendors.map((vendor) => (
                      <option
                        key={vendor.vendor_id || vendor.id}
                        value={vendor.vendor_id || vendor.id}
                      >
                        {vendor.vendor_name || vendor.name} —{" "}
                        {vendor.vendor_code || vendor.code}
                      </option>
                    ))}
                  </select>
                  <button
                    className="ev-vendor-remove"
                    onClick={() =>
                      setF(
                        "vendors",
                        form.vendors.filter((_, j) => j !== i),
                      )
                    }
                  >
                    ×
                  </button>
                </div>
              ))}
              <button
                className="ev-btn ev-btn-dark-sm"
                style={{ marginTop: 10 }}
                onClick={() =>
                  setF("vendors", [...form.vendors, { id: 0, vendor_id: "" }])
                }
              >
                + Add Vendor
              </button>
            </div>
            <div className="ev-assigned-box" style={{ marginTop: 18 }}>
              <div className="ev-assigned-label">Assigned Vendors</div>
              {form.vendors.length === 0 ? (
                <p className="ev-assigned-empty">No vendors added yet.</p>
              ) : (
                <div className="ev-assigned-tags">
                  {form.vendors.map((v, i) => (
                    <span key={i} className="ev-assigned-tag">
                      Vendor #{v.vendor_id}
                      <button
                        onClick={() =>
                          setF(
                            "vendors",
                            form.vendors.filter((_, j) => j !== i),
                          )
                        }
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {step === 4 && (
          <div className="ev-fcard">
            <div className="ev-act-header">
              <div className="ev-fcard-eyebrow" style={{ marginBottom: 0 }}>
                Event Activities & Plans
              </div>
              <button
                className="ev-btn ev-btn-dark-sm"
                onClick={() => setShowActForm(true)}
              >
                + Add Activity
              </button>
            </div>
            {showActForm && (
              <div className="ev-act-form-box">
                <div className="ev-fgrid">
                  <div className="ev-fgroup ev-fcol-full">
                    <label>Activity Title *</label>
                    <input
                      value={newAct.activity_title}
                      onChange={(e) =>
                        setNewAct((p) => ({
                          ...p,
                          activity_title: e.target.value,
                        }))
                      }
                      placeholder="e.g. Welcome Champagne Reception"
                    />
                  </div>
                  <div className="ev-fgroup">
                    <label>Start Date & Time</label>
                    <input
                      type="datetime-local"
                      value={newAct.start_date}
                      onChange={(e) =>
                        setNewAct((p) => ({ ...p, start_date: e.target.value }))
                      }
                    />
                  </div>
                  <div className="ev-fgroup">
                    <label>End Date & Time</label>
                    <input
                      type="datetime-local"
                      value={newAct.end_date}
                      onChange={(e) =>
                        setNewAct((p) => ({ ...p, end_date: e.target.value }))
                      }
                    />
                  </div>
                  <div className="ev-fgroup">
                    <label>Assignee (User ID)</label>
                    <input
                      type="number"
                      value={newAct.assignee}
                      onChange={(e) =>
                        setNewAct((p) => ({ ...p, assignee: e.target.value }))
                      }
                      placeholder="1"
                    />
                  </div>
                  <div className="ev-fgroup">
                    <label>Budget (₫)</label>
                    <input
                      type="number"
                      value={newAct.budget}
                      onChange={(e) =>
                        setNewAct((p) => ({ ...p, budget: e.target.value }))
                      }
                      placeholder="10000"
                    />
                  </div>
                  <div className="ev-fgroup">
                    <label>Status</label>
                    <select
                      value={newAct.status}
                      onChange={(e) =>
                        setNewAct((p) => ({ ...p, status: e.target.value }))
                      }
                    >
                      <option value="Pending">Pending</option>
                      <option value="In Progress">In Progress</option>
                      <option value="Completed">Completed</option>
                    </select>
                  </div>
                  <div className="ev-fgroup ev-fcol-full">
                    <label>Description</label>
                    <input
                      value={newAct.description}
                      onChange={(e) =>
                        setNewAct((p) => ({
                          ...p,
                          description: e.target.value,
                        }))
                      }
                      placeholder="Brief description"
                    />
                  </div>
                </div>
                <div className="ev-act-form-btns">
                  <button
                    className="ev-btn ev-btn-ghost"
                    onClick={() => setShowActForm(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="ev-btn ev-btn-accent"
                    onClick={addActivity}
                  >
                    Add
                  </button>
                </div>
              </div>
            )}
            {form.activities.length === 0 && !showActForm ? (
              <div className="ev-act-empty">
                No activities yet. Click "+ Add Activity" above.
              </div>
            ) : (
              <div className="ev-act-list">
                {form.activities.map((a, i) => (
                  <div key={i} className="ev-act-row">
                    <div className="ev-act-num">{i + 1}</div>
                    <div className="ev-act-body">
                      <div className="ev-act-name">
                        {a.activity_title || a.title}
                        {a.start_date && (
                          <span className="ev-act-time">
                            {" "}
                            @ {a.start_date.slice(11, 16)}
                          </span>
                        )}
                      </div>
                      {a.description && (
                        <div className="ev-act-desc">{a.description}</div>
                      )}
                      {a.budget && (
                        <div className="ev-act-desc">
                          Budget: {fmt(a.budget)} · {a.status}
                        </div>
                      )}
                    </div>
                    <button
                      className="ev-act-del"
                      onClick={() =>
                        setF(
                          "activities",
                          form.activities.filter((_, j) => j !== i),
                        )
                      }
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <div className="ev-form-footer">
          <div className="ev-footer-r">
            <button className="ev-btn ev-btn-ghost" onClick={closeForm}>
              Cancel
            </button>
            {step > 0 && (
              <button className="ev-btn ev-btn-ghost" onClick={goBack}>
                ← Back
              </button>
            )}
            {/* <button className="ev-btn ev-btn-draft">Save Draft</button> */}
            {step < STEPS.length - 1 ? (
              <button className="ev-btn ev-btn-primary-dark" onClick={goNext}>
                Next →
              </button>
            ) : (
              <>
                <button
                  className="ev-btn ev-btn-create"
                  disabled={formLoading}
                  onClick={isEditMode ? handleUpdate : handleCreate}
                >
                  {formLoading
                    ? "Saving…"
                    : isEditMode
                      ? "Update Event"
                      : "Create Event"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );

  // ── EVENT LIST ──
  return (
    <div className="ev-list-page">
      {showSuccess && (
        <SuccessModal
          eventTitle={createdTitle}
          onClose={() => setShowSuccess(false)}
        />
      )}
      <div className="ev-list-top">
        <div className="ev-list-top-left">
          <h1 className="ev-page-title">Events</h1>
          <p className="ev-page-sub">
            Manage culinary events, activities and ticketing
          </p>
        </div>
        <div className="ev-list-top-right">
          <div className="ev-tab-group">
            {STATUS_TABS.map((t) => (
              <button
                key={t}
                className={`ev-tab ${activeTab === t ? "ev-tab-on" : ""}`}
                onClick={() => setActiveTab(t)}
              >
                {t === "Drafts" ? "✏️ Drafts" : t}
              </button>
            ))}
          </div>
          <button className="ev-btn ev-btn-create" onClick={openAdd}>
            + Create Event
          </button>
        </div>
      </div>
      {listError && <div className="ev-form-error">{listError}</div>}
      <div className="ev-cards">
        {loading ? (
          <div className="ev-no-events" style={{ color: "#9F8E87" }}>
            Loading events…
          </div>
        ) : filtered.length === 0 ? (
          <div className="ev-no-events">No events for this filter.</div>
        ) : (
          filtered.map((e) => (
            <EventCard key={e.id || e.event_id} event={e} onEdit={openEdit} />
          ))
        )}
      </div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════
//  ROOT — Two-view page
// ═════════════════════════════════════════════════════════
export default function EventsPage() {
  const [view, setView] = useState("events");

  return (
    <div
      style={{
        height: "100vh",
        background: "#F7F4F0",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* FIXED TOP TABS */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "2px 32px 0",
          gap: 0,
          borderBottom: "2px solid #DDC8B3",
          background: "#F7F4F0",
          flexShrink: 0, // IMPORTANT: tabs will not scroll
          zIndex: 10,
        }}
      >
        <button
          onClick={() => setView("events")}
          style={{
            height: 40,
            padding: "0 24px",
            border: "none",
            background: "transparent",
            fontSize: 14,
            fontWeight: 600,
            fontFamily: "Inter, sans-serif",
            cursor: "pointer",
            color: view === "events" ? "#2A070C" : "#9F8E87",
            borderBottom:
              view === "events" ? "2px solid #A27B5B" : "2px solid transparent",
            marginBottom: -2,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <img
            src={eventIcon}
            alt="Events"
            style={{
              width: 20,
              height: 20,
              objectFit: "contain",
            }}
          />
          <span>Events</span>
        </button>

        <button
          onClick={() => setView("approvals")}
          style={{
            height: 40,
            padding: "0 24px",
            border: "none",
            background: "transparent",
            fontSize: 14,
            fontWeight: 600,
            fontFamily: "Inter, sans-serif",
            cursor: "pointer",
            color: view === "approvals" ? "#2A070C" : "#9F8E87",
            borderBottom:
              view === "approvals"
                ? "2px solid #A27B5B"
                : "2px solid transparent",
            marginBottom: -2,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <img
            src={approveIcon}
            alt="Approvals"
            style={{
              width: 20,
              height: 20,
              objectFit: "contain",
            }}
          />
          <span>Approvals</span>
        </button>
      </div>

      {/* ONLY THIS AREA WILL SCROLL */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {view === "events" && <EventsView />}
        {view === "approvals" && <ApprovalView />}
      </div>
    </div>
  );
}
